
import { useParams } from "react-router-dom";
import { useClientDetail } from "@/hooks/useClientDetail";
import { ClientDetailLoading } from "@/components/clients/ClientDetailLoading";
import { ClientDetailError } from "@/components/clients/ClientDetailError";
import { ClientDetailContent } from "@/components/clients/ClientDetailContent";
import { useUserProfile } from "@/hooks/useUserProfile";

export default function ClientDetail() {
  const { id } = useParams();
  const { avatarUrl, name } = useUserProfile();
  const { isLoading, client, error } = useClientDetail(id);

  if (isLoading) {
    return <ClientDetailLoading avatarUrl={avatarUrl} name={name} />;
  }

  if (error || !client) {
    return <ClientDetailError avatarUrl={avatarUrl} name={name} error={error} />;
  }

  return <ClientDetailContent client={client} avatarUrl={avatarUrl} name={name} />;
}
